import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import * as Model from './helpdesk.model'

@Injectable({
    providedIn: 'root'
})
export class HelpdeskService {

    constructor(private http: HttpClient) { }

    // Add Bug Report
    addReport(body: Model.HelpdeskReport): Observable<string> {
        return this.http.post<string>(`/bugReports/create`, body);
        // return this.http.post<void>(`/bugReports/`, body);
    }

    // Get Bug Reports For User
    getReports(): Observable<Model.HelpdeskReport[]> {
        return this.http.get<Model.HelpdeskReport[]>(`/bugReports/reportlist`);
        // return this.http.get<BugReport[]>(`/bugReports/user`);
    }
}
